'use strict';

import type { UserVoipExtension } from '../../Entities/User/UserVoipExtension';
import { EntityCollection } from '../EntityCollection';

export class UserVoipExtensionCollection extends EntityCollection<UserVoipExtension> {}
